
import { motion, useReducedMotion } from "framer-motion";

/**
 * Staggered word-by-word headline reveal: fade + slight upward motion +
 * blur-to-sharp. Used sparingly (hero, section intros) per the "restrained
 * animation" brief — not applied to every heading on the page.
 */
export default function AnimatedHeadline({
  text,
  as: Tag = "h1",
  className,
  delay = 0,
}: {
  text: string;
  as?: "h1" | "h2" | "h3";
  className?: string;
  delay?: number;
}) {
  const reduced = useReducedMotion();
  const words = text.split(" ");

  return (
    <Tag className={className}>
      {words.map((word, i) => (
        <span key={i} className="inline-block overflow-hidden pb-1 mr-[0.25em]">
          <motion.span
            className="inline-block"
            initial={
              reduced
                ? { opacity: 0 }
                : { opacity: 0, y: "100%", filter: "blur(8px)" }
            }
            animate={
              reduced
                ? { opacity: 1 }
                : { opacity: 1, y: "0%", filter: "blur(0px)" }
            }
            transition={{
              duration: 0.8,
              delay: delay + i * 0.06,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            {word}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
